import {Skeleton, Spin} from "antd";

export default function RenderLoading({
                                          loading = false,
                                          children,
                                          skeleton = false,
                                          spin = false
                                      }) {
    if (!loading) return children;
    if (skeleton === true) return (<Skeleton loading={true} active={true}/>);
    if (skeleton) return skeleton;
    if (spin === true) return (<Spin spinning={loading}></Spin>);
    if (spin) return spin;
    return (<Spin spinning={loading}></Spin>);


};
